import React from 'react'
import Navbar from '../inc/Navbar'
import { Link } from "react-router-dom";
import blazer from "../images/blazer.jpg";
import tshirtmens from "../images/mens.jpg"
import Panjabi from "../images/panjabi_men.jpg";
import Shirt from "../images/shirt.jpg";
import Jeans from "../images/jeans_men.jpg";

function Menswear() {
  return (
    <div>
      <Navbar />
      <br />
      <br />
      <br />
      <br />
      <br />

      <div className='nadiacloth'>
        <div className="album py-1">
          <div className="container mt-4">
            <nav aria-label="breadcrumb">
              <ol className="breadcrumb">
                <li className="breadcrumb-item"><Link to="/" href="#">Home</Link></li>
                <li className="breadcrumb-item active" aria-current="page">Mens Wear</li>
              </ol>
            </nav>
          </div>
        </div>
      </div>

      <div className="album py-2">
        <div className="container">
          <div className="row">
            <div className="col-md-6">
              <div className="d-flex justify-content-start align-items-center mb-2">
                <div className="col-md-6 me-2 mt-3">
                  <a href='blazer-men'>
                    <div className="card">
                      <img src={blazer} className="card-img-top" alt="blazer" />
                      <div className="card-body">
                        <h5 className="card-title mb-1">Blazer</h5>
                        <p className="card-text">Best blazer available</p>
                        <a href="blazer-men" className="learn">Learn More <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-arrow-right" viewBox="0 0 16 16">
                          <path fill-rule="evenodd" d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8" />
                        </svg></a>
                      </div>
                    </div>
                  </a>
                </div>
                <div className="col-md-6 mt-3">
                  <a href='men-tshirt'>
                    <div className="card" >
                      <img src={tshirtmens} className="card-img-top" alt="tshirtmens" />
                      <div className="card-body">
                        <h5 className="card-title mb-1">T-Shirt</h5>
                        <p className="card-text">Best T-Shirt available</p>
                        <a href="men-tshirt" className="learn">Learn More <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-arrow-right" viewBox="0 0 16 16">
                          <path fill-rule="evenodd" d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8" />
                        </svg></a>
                      </div>
                    </div>
                  </a>
                </div>

              </div>
            </div>
            <div className="col-md-6">
              <div className="d-flex justify-content-start align-items-center mb-2">
                <div className="col-md-6 me-2 mt-3">
                  <a href='Panjabi'>
                    <div className="card">
                      <img src={Panjabi} className="card-img-top" alt="Panjabi" />
                      <div className="card-body">
                        <h5 className="card-title mb-1">Panjabi</h5>
                        <p className="card-text"><small>Best panjabi available</small></p>
                        <a href="Panjabi" className="learn">Learn More <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-arrow-right" viewBox="0 0 16 16">
                          <path fill-rule="evenodd" d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8" />
                        </svg></a>
                      </div>
                    </div>
                  </a>
                </div>
                <div className="col-md-6 mt-3">
                  <a href='Men-shirt'>
                    <div className="card">
                      <img src={Shirt} className="card-img-top" alt="Best Shirt Bethaudahari" />
                      <div className="card-body">
                        <h5 className="card-title mb-1">Shirt</h5>
                        <p className="card-text">Best Shirt available</p>
                        <a href="Men-shirt" className="learn">Learn More <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-arrow-right" viewBox="0 0 16 16">
                          <path fill-rule="evenodd" d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8" />
                        </svg></a>
                      </div>
                    </div>
                    </a>
                </div>


              </div>
            </div>

          </div>
        </div>
      </div>
      <div className="album py-2">
        <div className="container">
          <div className="row">
            <div className="col-md-6">
              <div className="d-flex justify-content-start align-items-center mb-2">
                <div className="col-md-6 me-2 mt-3">
                  <a href='men-jeans'>
                    <div className="card">
                      <img src={Jeans} className="card-img-top" alt="Jeans" />
                      <div className="card-body">
                        <h5 className="card-title mb-1">Jeans</h5>
                        <p className="card-text">Best Jeans available</p>
                        <a href="men-jeans" className="learn">Learn More <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-arrow-right" viewBox="0 0 16 16">
                          <path fill-rule="evenodd" d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8" />
                        </svg></a>
                      </div>
                    </div>
                  </a>
                </div>
                {/* <div className="col-md-6 me-2 mt-3">
                  <a href='men-jeans'>
                    <div className="card">
                      <img src={Jeans} className="card-img-top" alt="Jeans" />
                      <div className="card-body">
                        <h5 className="card-title mb-1">Jeans</h5>
                        <p className="card-text">Best Jeans available</p>
                        <a href="men-jeans" className="learn">Learn More <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-arrow-right" viewBox="0 0 16 16">
                          <path fill-rule="evenodd" d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8" />
                        </svg></a>
                      </div>
                    </div>
                  </a>
                </div> */}

              </div>
            </div>


          </div>
        </div>
      </div>


      <br />
    </div>
  )
}

export default Menswear